import dayjs from "dayjs"

// Croatian locale is faulty in dayjs, so we have to use the fixed one locally. Wit until this PR merged https://github.com/iamkun/dayjs/pull/2723
// import localeHr from 'dayjs/locale/hr'
import localeHr from '@/js/includes/dayjs-locale/hr'
import localeLt from 'dayjs/locale/lt'
import localeEn from 'dayjs/locale/en'

const locales = {
	hr: localeHr,
	lt: localeLt,
	en: localeEn,
}

import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)

import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

// // Register dayjs globally
// window.dayjs = dayjs

export function setLocale(locale){
	return dayjs.locale(locales[locale])
}

export default dayjs